/**
 * @generated SignedSource<<719ba8c88213764163702d5203250fae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ActiveUntilPeriodType = "PERIOD_AFTER_ACTIVATION" | "SPECIFIC_DATE";
export type Duration = "DAY" | "MONTH" | "WEEK" | "YEAR";
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type StorePackageSummary_package$data = {
  readonly __typename: string;
  readonly activeUntilPeriod: number | null | undefined;
  readonly activeUntilPeriodType: ActiveUntilPeriodType | null | undefined;
  readonly activeUntilPeriodUnit: Duration | null | undefined;
  readonly billingType: PackageBillingType;
  readonly endOn: string | null | undefined;
  readonly id: string | null | undefined;
  readonly startOn: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetMinimumCommitment_package" | "useGetPackagePriceMap_package">;
  readonly " $fragmentType": "StorePackageSummary_package";
};
export type StorePackageSummary_package$key = {
  readonly " $data"?: StorePackageSummary_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageSummary_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageSummary_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeUntilPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeUntilPeriodUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeUntilPeriodType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPackagePriceMap_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetMinimumCommitment_package"
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "28afb580b75c651478ce1456fe6668f6";

export default node;
